/* eslint-disable no-console */
import { io } from 'socket.io-client';

// Mismo origen que la web por defecto (proxy de React en desarrollo, nginx en produccion)
const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || window.location.origin;
const API_URL = process.env.REACT_APP_API_URL || '/api';

/**
 * INSTANCIA GLOBAL DE SOCKET.IO
 *
 * 🛡️ FIX M1: ciclo de vida robusto.
 *  - autoConnect:false → NUNCA conecta antes de haber sesión (antes conectaba al
 *    importar el módulo, sin cookie → 401, y quemaba los reintentos).
 *  - reconnectionAttempts:Infinity → el tiempo real de una app clínica no debe
 *    "rendirse" tras 5 fallos y quedar muerto hasta recargar la página.
 *  - reconnectionDelayMax + randomizationFactor → backoff con techo para no
 *    martillear al servidor durante una caída prolongada.
 *  La conexión/desconexión la gobierna AuthContext (login/logout/sesión expirada).
 */
const socket = io(SOCKET_URL, {
    autoConnect: false,
    withCredentials: true,
    transports: ['websocket', 'polling'],
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 2000,
    reconnectionDelayMax: 30000,
    randomizationFactor: 0.5
});

// 🔄 El accessToken (JWT) dura 15 min. Si el handshake falla por token caducado,
// renovamos la sesión vía /auth/refresh (cookie httpOnly) y reintentamos UNA vez.
let renovandoSesion = false;
socket.on('connect_error', async (error) => {
    if (process.env.NODE_ENV !== 'production') {
        console.error('%c🚨 Fallo de conexión en Sockets:', 'color:#ef4444;font-weight:bold;', error.message);
    }
    if (renovandoSesion) return;
    renovandoSesion = true;
    try {
        await fetch(`${API_URL}/auth/refresh`, { method: 'POST', credentials: 'include' });
        socket.connect(); // reintento con la cookie renovada
    } catch {
        // Si el refresh falla, el interceptor HTTP de api.js gestionará la sesión expirada.
    } finally {
        renovandoSesion = false;
    }
});

/**
 * 🕵️‍♂️ AUDITORÍA DE RED EN ENTORNO DE DESARROLLO
 */
if (process.env.NODE_ENV !== 'production') {
    socket.on('connect', () => {
        console.log(`%c⚡ Canal WebSockets Establecido -> ID: ${socket.id}`, 'color: #10b981; font-weight: bold;');
    });

    socket.on('disconnect', (reason) => {
        console.warn(`%c🔌 Canal WebSockets Interrumpido. Motivo: ${reason}`, 'color: #f59e0b; font-weight: bold;');
    });
}

export default socket;
